import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import { RootState } from "features/config/store";
import { TeiHubLinkCreateStoreParam } from "features/hublink/core/tei-hub-link.param";
import {
  teiHubLinkCreateStoreRepository,
  teiHubLinkCreateStoreResponse,
} from "features/hublink/data/tei-hub-link.repository";

export enum TeiHubLinkCreateStoreState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: TeiHubLinkCreateStoreState;
  message: string;
}

const initialState: InitialState = {
  status: TeiHubLinkCreateStoreState.initial,
  message: "",
};

export const teiHubLinkCreateStore = createAsyncThunk(
  "teiHubLinkCreateStore",
  async (param: TeiHubLinkCreateStoreParam, { rejectWithValue }) => {
    try {
      const response: teiHubLinkCreateStoreResponse =
        await teiHubLinkCreateStoreRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const teiHubLinkCreateStoreSlice = createSlice({
  name: "teiHubLinkCreateStore",
  initialState,
  reducers: {
    resetTeiHubLinkCreateStore: (state) => {
      state.status = TeiHubLinkCreateStoreState.initial;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(teiHubLinkCreateStore.pending, (state) => {
        state.status = TeiHubLinkCreateStoreState.inProgress;
      })
      .addCase(teiHubLinkCreateStore.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = TeiHubLinkCreateStoreState.success;
          state.message = message;
        }
      })
      .addCase(teiHubLinkCreateStore.rejected, (state, action) => {
        state.status = TeiHubLinkCreateStoreState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectTeiHubLinkCreateStore = (state: RootState) =>
  state.teiHubLinkCreateStore;
export const { resetTeiHubLinkCreateStore } =
  teiHubLinkCreateStoreSlice.actions;

export default teiHubLinkCreateStoreSlice.reducer;
